import React from 'react';
import { Container, Card, Button, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';

const CoachesCorner: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Coaches Corner | Ashridge Park FC</title>
        <meta name="description" content="Resources and downloads for Ashridge Park FC coaches." />
      </Helmet>
      <Container className="p-3 my-4">
        <h2 className="mb-4">COACHES CORNER</h2>
        <p className="mb-4">Resources, forms and information for Ashridge Park FC coaches.</p>

        <Card className="mb-4">
          <Card.Header as="h5" style={{ backgroundColor: '#254E97', color: 'white' }}>
            Downloads
          </Card.Header>
          <Card.Body>
            <Card.Title>Expenses Form</Card.Title>
            <Card.Text>
              Submit your coaching expenses using this spreadsheet.
            </Card.Text>
            <Button
              as="a"
              variant="outline-primary"
              href="/content/Expenses.xlsx"
              download
            >
              Download Expenses (.xlsx)
            </Button>
          </Card.Body>
        </Card>

        <Row>
          <Col md={6} className="mb-4">
            <Card>
              <Card.Header as="h5" style={{ backgroundColor: '#254E97', color: 'white' }}>
                Video 1
              </Card.Header>
              <Card.Body>
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/Ma-G6gTI3sA?start=26"
                    title="Coaches Corner Video 1"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="mb-4">
            <Card>
              <Card.Header as="h5" style={{ backgroundColor: '#254E97', color: 'white' }}>
                Video 2
              </Card.Header>
              <Card.Body>
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/kD-sJoSi1d0"
                    title="Coaches Corner Video 2"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CoachesCorner;
